export default "__VITE_ASSET__BFhHwdX9__"